import { render, staticRenderFns } from "./Swaps.vue?vue&type=template&id=50aba95f&scoped=true"
import script from "./Swaps.js?vue&type=script&lang=js&external"
export * from "./Swaps.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50aba95f",
  null
  
)

export default component.exports